<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Užívateľ</span>
          <v-subheader>ID: {{ id }}</v-subheader>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  label="Meno*"
                  v-model="name"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="isadmin"
                  label="Administrátor aplikácie"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Email*"
                  v-model="email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indikuje povinné polia</small>
        </v-card-text>

        <v-card-actions>
          <span v-if="password !== ''" class="title">Heslo:&nbsp;</span>
          <span v-if="password !== ''" class="title font-weight-thin">{{
            password
          }}</span>
          <div class="flex-grow-1"></div>

          <v-btn color="alert" text @click="deleteUser()">Vymazať</v-btn>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="id === ''"
                color="blue darken-1"
                text
                @click="newPassword()"
                v-on="on"
                >Heslo</v-btn
              >
            </template>
            <v-span>Generovať nové heslo</v-span>
          </v-tooltip>

          <v-btn color="primary" text @click="dialog = false">Zavrieť</v-btn>
          <v-btn color="primary" text @click="save()">Uložiť</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "UserDetail",

  data: () => ({
    dialog: false,
    name: "",
    email: "",
    id: "",
    isadmin: false,
    password: "",

    valid: true,
    nameRules: [
      v => !!v || "Meno musí byť zadané",
      v => (v && v.length >= 6) || "Meno musí mať najmenej 6 znakov"
    ],
    emailRules: [
      v => !!v || "E-mail musí byť zadaný",
      v => /.+@.+/.test(v) || "E-mail nemá správny formát"
    ]
  }),

  methods: {
    show: function(user) {
      this.dialog = true
      this.name = user.Name
      this.email = user.Email
      this.isadmin = user.IsAdmin
      this.id = user.ID
      this.password = ""
      console.log("EDIT USER", user)
    },

    async save() {
      if (this.$refs.form.validate()) {
        try {
          let response = await this.$axios.post("/r/user", {
            id: this.id,
            name: this.name,
            email: this.email,
            isadmin: this.isadmin
          })
          if (response.status === 200) {
            if (response.data.mode === "insert") {
              this.$store.commit(
                "message",
                "Užívateľ založený. Uložte si jeho vygenerované heslo."
              )
              this.id = response.data.id
              this.password = response.data.password
            } else {
              this.$store.commit("message", "Údaje zmenené.")
              this.dialog = false
            }
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      } else {
        this.$store.commit("alert", "Vo formulári sú chyby")
      }
    },

    //generovat nove heslo
    async newPassword() {
      try {
        let response = await this.$axios.post("/r/newpassword", {
          id: this.id
        })
        if (response.status === 200) {
          this.password = response.data.password
          this.$store.commit("message", "Zmena hesla bola úspešná")
          this.$emit("change")
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },

    async deleteUser() {
      if (confirm("Naozaj vymazať užívateľa z databázy ?")) {
        try {
          let response = await this.$axios.delete("/r/user/" + this.id)
          if (response.status === 200) {
            this.$store.commit("message", "Užívateľ je vymazaný.")
            this.dialog = false
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    }
  }
}
</script>
